import { render, staticRenderFns } from "./step-display.vue?vue&type=template&id=3a526bef&scoped=true"
import script from "./step-display.vue?vue&type=script&lang=ts"
export * from "./step-display.vue?vue&type=script&lang=ts"
import style0 from "./step-display.vue?vue&type=style&index=0&id=3a526bef&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a526bef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a526bef')) {
      api.createRecord('3a526bef', component.options)
    } else {
      api.reload('3a526bef', component.options)
    }
    module.hot.accept("./step-display.vue?vue&type=template&id=3a526bef&scoped=true", function () {
      api.rerender('3a526bef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/step-display/step-display.vue"
export default component.exports